import { profile as en_profile } from "../en/profile";

/** profile — ES slice (39 keys). */
export const profile: Record<keyof typeof en_profile, string> = {
  profile_info_interests_label: "Intereses",
  profile_info_about_label: "Sobre mí",
  profile_info_photos_label: "Fotos",
  profile_info_distance_mi: "{miles} mi",
  profile_info_distance_mi_nearby: "cerca",
  profile_info_full_name_age: "{name}, {age}",
  profile_edit_gender_label: "Género",
  profile_edit_about_label: "Sobre mí",
  profile_edit_first_name_label: "Nombre",
  profile_edit_last_name_label: "Apellido",
  profile_edit_first_name_placeholder: "Escribe tu nombre",
  profile_edit_last_name_placeholder: "Escribe tu apellido",
  profile_edit_about_placeholder: "vivir, reír, amar, ¿o no?",
  profile_edit_gender_text_none: "Prefiero no decirlo",
  profile_edit_gender_text_male: "Hombre",
  profile_edit_gender_text_female: "Mujer",
  profile_edit_birthdate_label: "Fecha de nacimiento",
  profile_edit_birthdate_placeholder_day: "Día",
  profile_edit_birthdate_placeholder_month: "Mes",
  profile_edit_birthdate_placeholder_year: "Año",
  profile_filter_gender_label: "Me interesa conocer a",
  profile_filter_age_label: "Edad",
  profile_filter_age_min_label: "Desde",
  profile_filter_age_max_label: "Hasta",
  profile_filter_distance_label: "Distancia",
  profile_filter_distance_label_value: "{radius} mi",
  profile_filter_gender_value_text_none: "Todos",
  profile_filter_gender_value_text_male: "Hombre",
  profile_filter_gender_value_text_female: "Mujer",
  profile_menu_edit_title: "Editar perfil",
  profile_menu_edit_subtitle: "Actualiza tu info básica y tu bio",
  profile_menu_filters_title: "Filtros",
  profile_menu_filters_subtitle: "Ajusta a quién quieres conocer",
  profile_menu_photos_title: "Fotos",
  profile_menu_photos_subtitle: "Gestiona o reordena tu galería",
  profile_menu_interests_title: "Intereses",
  profile_menu_interests_subtitle: "Muestra lo que te importa",
  profile_menu_settings_title: "Ajustes",
  profile_menu_settings_subtitle: "Gestiona tu cuenta y preferencias",
};
